import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function ChurchBudgetEstimatorTool() {
  const [weeklyTithes, setWeeklyTithes] = useState('10000');
  const [pastoralStaffPct, setPastoralStaffPct] = useState('45');
  const [facilityUpkeepPct, setFacilityUpkeepPct] = useState('20');
  const [missionsOutreachPct, setMissionsOutreachPct] = useState('15');

  const tithes = parseFloat(weeklyTithes) || 0;
  const staffPct = parseFloat(pastoralStaffPct) || 0;
  const facilityPct = parseFloat(facilityUpkeepPct) || 0;
  const missionsPct = parseFloat(missionsOutreachPct) || 0;

  const staffAmount = tithes * (staffPct / 100);
  const facilityAmount = tithes * (facilityPct / 100);
  const missionsAmount = tithes * (missionsPct / 100);

  const remainingPct = 100 - (staffPct + facilityPct + missionsPct);
  const remainingAmount = tithes * (remainingPct / 100);

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Revenue & Targets</h3>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Average Weekly Tithes & Offerings</label>
            <Input type="number" value={weeklyTithes} onChange={e => setWeeklyTithes(e.target.value)} />
          </div>
          <div className="grid grid-cols-3 gap-4 pt-4 border-t">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400 block mb-1">Staff (%)</label>
              <Input type="number" value={pastoralStaffPct} onChange={e => setPastoralStaffPct(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400 block mb-1">Facility (%)</label>
              <Input type="number" value={facilityUpkeepPct} onChange={e => setFacilityUpkeepPct(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400 block mb-1">Missions (%)</label>
              <Input type="number" value={missionsOutreachPct} onChange={e => setMissionsOutreachPct(e.target.value)} />
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-4">
        <Card className="p-6 bg-slate-50 border-slate-200 dark:bg-slate-900/20">
          <p className="text-[10px] uppercase font-bold text-slate-500 mb-4">Weekly Budget Allocations</p>
          <div className="space-y-4 font-mono text-sm">
             <div className="flex justify-between items-end border-b border-dashed border-gray-200 pb-2">
               <div><span className="text-gray-500 block text-[10px] uppercase">Pastoral / Staff</span><span className="font-bold">{staffPct}%</span></div>
               <span className="font-bold text-lg">${staffAmount.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
             </div>
             <div className="flex justify-between items-end border-b border-dashed border-gray-200 pb-2">
               <div><span className="text-gray-500 block text-[10px] uppercase">Facility Upkeep</span><span className="font-bold">{facilityPct}%</span></div>
               <span className="font-bold text-lg">${facilityAmount.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
             </div>
             <div className="flex justify-between items-end border-b border-dashed border-gray-200 pb-2">
               <div><span className="text-gray-500 block text-[10px] uppercase">Missions / Outreach</span><span className="font-bold">{missionsPct}%</span></div>
               <span className="font-bold text-lg">${missionsAmount.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
             </div>
             <div className="flex justify-between items-end pb-2">
               <div><span className="text-gray-500 block text-[10px] uppercase">Remaining / Operations</span><span className="font-bold text-amber-600">{remainingPct}%</span></div>
               <span className="font-bold text-lg text-amber-700">${remainingAmount.toLocaleString(undefined, {minimumFractionDigits: 2})}</span>
             </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

